import IParser from "@/types/IParser"
import { IUserCancellation } from "./userCancellation.types"
import { UserCancellation } from "./userCancellation"
import ParseError from "@/types/ParseError"
import dayjs from "dayjs"

type IUserCancellationRaw = {
  id: number
  created_at: string
}

export const UserCancellationParser: IParser<
  IUserCancellation,
  IUserCancellationRaw
> = {
  toDomain: (data) => {
    try {
      return new UserCancellation(data.id, dayjs(data.created_at))
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
